// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jcgI","left":"styles_left__32mmH"};